<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container justify-content-between d-lg-flex d-none" style="font-weight: bold;">
        <a class="navbar-brand d-flex" href="/"><img src="../assets/img/logo/logo-name.svg" style="height: 40px" alt=""></a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
          <ul class="navbar-nav">
            <li class="nav-item mx-4">
              <a class="nav-link" href="/product">محصولات</a>
            </li>
            <li class="nav-item mx-4">
              <a class="nav-link" href="/demo">دموها</a>
            </li>
            <li class="nav-item mx-4">
              <a class="nav-link" href="/blogs">وبلاگ</a>
            </li>
            <li class="nav-item mx-4">
              <a class="nav-link" aria-current="page" href="/about">درباره ما</a>
            </li>
            
            <li class="nav-item mx-4">
              <a class="nav-link" href="/contact">ارتباط با ما</a>
            </li>
            
          </ul>
        </div>
        <div class="dropdown">
          <a class="nav-link dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">زبان</a>
          
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li><a class="px-4 text-dark" style="text-decoration: none;" @click="changeLang('en')">EN</a></li>
            <li><a class="px-4 text-dark" style="text-decoration: none;" @click="changeLang('fa')">FA</a></li>
          </ul>
        </div>
        
        <div class="d-flex">
          <button class="btn-bg-white mx-4" @click="router.push({'name':'contact'})">درخواست دمو</button>
          <button v-if="token" class="btn-bg-white" @click="signOut()">خروج</button>
          <button v-else-if="!token" class="btn-bg-white" @click="router.push({'name':'sign-in'})">ورود</button>
          <!-- <FontAwesomeIcon icon="fa-regular fa-bell" class="text-gray-custom fs-3 my-auto mt-2 mx-2"/> -->
          
          <!-- <div class="dropdown">
            <div class="dropdown-toggle" type="button" data-bs-toggle="dropdown">
              <img src="../assets/img/portfolio/Ellipse 3928.png" style="width: 40px;cursor: pointer;height: 40px;" alt="">
            </div>
            
            <ul class="dropdown-menu">
              <li><a class="dropdown-item text-gray-custom" href="/profile"><FontAwesomeIcon icon="fa-solid fa-user" class="fs-6 mx-2"/>View Profile</a></li>
              <li><a class="dropdown-item text-gray-custom" href="/increase-credit"><FontAwesomeIcon icon="fa-regular fa-credit-card" class="fs-6 mx-2"/>Increase Credit</a></li>
              <li><a class="dropdown-item text-gray-custom" href="/transaction-history"><FontAwesomeIcon icon="fa-solid fa-box-archive" class="fs-6 mx-2"/>Transaction history</a></li>
            </ul>
          </div> -->
        </div>
      </div>
      <div class="container-fluid d-lg-none d-block" style="font-weight: bold;">
        <div class="d-flex justify-content-between">
          <a class="navbar-brand d-flex" href="/"><img src="../assets/img/logo/logo-name.svg" style="height: 40px" alt=""></a>
          <div>
            <div class="dropdown d-inline-flex">
              <a class="nav-link dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">زبان</a>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="px-4 text-dark" style="text-decoration: none;" @click="changeLang('en')">EN</a></li>
                <li><a class="px-4 text-dark" style="text-decoration: none;" @click="changeLang('fa')">FA</a></li>
              </ul>
            </div>
            <button class="navbar-toggler d-inline-flex" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
          
        </div>
        <div class="d-flex justify-content-between">
          <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav">
              <li class="nav-item mx-3">
                <a class="nav-link" href="/product">محصولات</a>
              </li>
              <li class="nav-item mx-3">
                <a class="nav-link" href="/demo">دموها</a>
              </li>
              <li class="nav-item mx-3">
                <a class="nav-link" href="/blogs">وبلاگ</a>
              </li>
              <li class="nav-item mx-3">
                <a class="nav-link" aria-current="page" href="/about">درباره ما</a>
              </li>
              
              <li class="nav-item mx-3">
                <a class="nav-link" href="/contact">ارتباط با ما</a>
              </li>
              
            </ul>
          </div>
        </div>
        
        <div class="d-flex float-end">
          <button class="btn-bg-white">درخواست دمو</button>
          <FontAwesomeIcon icon="fa-regular fa-bell" class="text-gray-custom fs-3 my-auto mt-2 mx-2"/>
          <img src="../assets/img/portfolio/Ellipse 3928.png" @click="router.push({'name':'profile'})" style="width: 40px;cursor: pointer;height: 40px;" alt="">
        </div>
      </div>
    </nav>
  </template>
  
  <script>
  import { defineComponent } from '@vue/composition-api';
  import { useRouter } from 'vue-router';
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { faBell,faCreditCard } from '@fortawesome/free-regular-svg-icons';
  import { faCaretDown,faUser,faBoxArchive } from '@fortawesome/free-solid-svg-icons';
  import { ref, watch } from 'vue';
  
  export default defineComponent({
    components: { FontAwesomeIcon },
    setup() {
      const router = useRouter()
      const token = ref(localStorage.getItem('token'))
      library.add(faBell,faCaretDown,faUser,faCreditCard,faBoxArchive)      

      function signOut() {
        localStorage.removeItem('token')
        localStorage.removeItem('user_id')
        router.push({'name':'sign-in'})
        token.value = false;
        console.log(router.currentRoute);
        
      }

      watch(router.currentRoute,()=>{
        if (localStorage.getItem('token')) {
          token.value = localStorage.getItem('token')
        }
      })

      if (!localStorage.getItem('lang')) {
            localStorage.setItem('lang', 'en')
        }

        function changeLang(lang) {
            localStorage.setItem('lang', lang)
            location.reload();
        }

      return {
        router,
        token,
        signOut,
        changeLang,
      }
  
    },
  })
  </script>
  <style scoped lang="scss">
  @import url('../assets/scss/navbar.scss');
  .navbar-profile {
    width: 50px;
    height: 50px;
    border: none;
    border-radius: 100%;
    cursor: pointer;
    box-shadow: 0px 0px 5px 0px #202020;
  
    @media(max-width:575px) {
      width: 40px;
      height: 40px;
    }
  }

  .navbar-collapse {
    flex-grow: 0;
}

.dropdown-item:hover {
  background: -webkit-linear-gradient(right,#001477, #00aeff,#00ffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
  </style>
  